import Link from 'next/link';

import styles from '@styles/dropAuction/howItWork.module.scss';

const StepOne = () => {
	return (
        <div className='col-sm-4'>
			<div className={styles.howitworkBoxFirst}>
				<div className={styles.stepOne}>
					<div className={styles.loginBox}>
						<div className={styles.stepNumber}>1</div>
						<input
							disabled
							type='text'
							defaultValue={'Find an auction item!'}
							alt=''
						/>
					</div>
					<div className={styles.stepText}>
						<h2>Choose your Item</h2>
						<p>
							Select the product you would like to bid for. Check out all
							upcoming Drops{' '}
							<Link href={`/drop-auctions/all`} style={{textDecoration: 'underline'}}>
								here
							</Link>
							.
						</p>
						<p>
							You can login to bid or participate as a guest if you prefer. Too
							easy!
						</p>
					</div>
				</div>
			</div>
		</div>
    );
};

export default StepOne;
